import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h1>
    <h2 {...{
      "id": "hobby-land"
    }}>{`Hobby Land`}</h2>
    <p><inlineCode parentName="p">{`Hobby Land`}</inlineCode>{` is a place to keep track of your hobbies. Add hobbies that are going well, just started, or need further pushes. `}</p>
    <p>{`When you add a hobby to the Hobby Land, you provide a rank or weightage. The higher the rank, the better you are doing with the hobby. Lower-ranked hobbies need attention. Hobby Land reminds you that you need to get better at your hobbies.`}</p>
    <p align="center">
  <a href="https://github.com/pedronauck/docz">
    <img alt="hobbyland" src="https://res.cloudinary.com/atapas/image/upload/v1632472779/demos/flow_hgywzs.gif" width="100%" />
  </a>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      